export default "__VITE_ASSET__DOFlbRGt__"